export default __webpack_public_path__ + "../images/android-chrome-512x512.png";